export default "__VITE_ASSET__DrbKbr7r__"